// Tier-2 <Progress> backed by AntD Progress (FORT-331). Line, circle or dashboard
// progress. Track/stroke colours come from AntD's token-sourced theme (success /
// exception statuses use the semantic palette), so no useTokens() here.
import React from 'react';
import { Progress as AntProgress } from 'antd';
import type { CommonProps } from './types';

export type ProgressType = 'line' | 'circle' | 'dashboard';
export type ProgressStatus = 'normal' | 'active' | 'success' | 'exception';

export interface ProgressProps extends CommonProps {
  /** Completion percentage, 0–100. */
  percent: number;
  type?: ProgressType;
  status?: ProgressStatus;
  /** Show the trailing percentage / status icon. Defaults to true. */
  showInfo?: boolean;
  size?: 'default' | 'small';
  /** Diameter for `circle`/`dashboard`; ignored for `line`. */
  width?: number;
}

export const Progress: React.FC<ProgressProps> = ({
  percent,
  type = 'line',
  status,
  showInfo = true,
  size = 'default',
  width,
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntProgress
    percent={percent}
    type={type}
    status={status}
    showInfo={showInfo}
    size={type === 'line' ? size : width}
    className={className}
    style={style}
    data-testid={dataTestId}
  />
);
